<template>
  <div class="align-self-start">
    <span class="text-capitalize d-block f-size-14" style="letter-spacing: 0px;">
      <v-icon icon="mdi-calendar" />
      {{ getCurrentDate }}
    </span>

    <span class="pt-4 pb-2 d-block f-size-10" style="letter-spacing: 0px;">*As atualizações podem levar até uma hora
      para serem refletidas no sistema.</span>
  </div>
</template>

<script>
import moment from "moment";

import { computed } from 'vue'

export default {
  setup() {
    const getCurrentDate = computed(() =>{
      return moment().format("dddd, DD/MM/YYYY")
    })

    return {
      getCurrentDate
    }
  }
}
</script>